import React, { useState, useEffect, useRef } from "react";
import {
  PageTemplate,
  PageTitle,
  PageSubtitle,
  TitleImage,
  CoverImage,
  ImageBridge,
  SectionByline,
} from "./components/unit";
import { Section, SectionFourth } from "./components/section";
import { ARTICLES } from "./asset/article";
import {
  SectionMap,
  SectionMapWithArticle,
  SectionMapParking,
} from "./components/map";
import { IMAGE_INFO } from "./components/constant";

function App() {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [mapPosition, setMapPosition] = useState(0);
  const [nextPosition, setNextPosition] = useState(0);
  const [isFixedPosition, setIsFixedPosition] = useState(false);
  const refMapbox = useRef(null);
  const refNextMapbox = useRef(null);
  const mapboxHeight = 700;
  const margin = mapboxHeight / 2;

  const handleScroll = () => {
    const currentPosition = window.pageYOffset;
    setScrollPosition(currentPosition);
  };

  const unlockFixed = () => {
    setIsFixedPosition(false);
    document.getElementsByTagName("body")[0].style.overflow = "auto";
  };

  const lockFixed = () => {
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
    setIsFixedPosition(true);
  };

  const moveToUp = () => {
    const up = mapPosition - margin - 10;
    unlockFixed();
    window.scrollTo(0, up);
  };

  const moveToDown = () => {
    const down = mapPosition + mapboxHeight + margin + 10;
    unlockFixed();
    window.scrollTo(0, down);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    if (scrollPosition) {
      if (
        scrollPosition > mapPosition - margin &&
        scrollPosition < mapPosition + mapboxHeight / 2
      ) {
        lockFixed();
      }
      if (scrollPosition > mapPosition + mapboxHeight + margin) {
        unlockFixed();
      }

      if (
        scrollPosition < mapPosition + mapboxHeight / 2 &&
        scrollPosition > mapPosition - margin
      ) {
        lockFixed();
      }
    }
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollPosition, mapPosition, margin]);

  useEffect(() => {
    if (refMapbox.current) {
      const target = refMapbox.current;
      const position = target.getBoundingClientRect();
      setMapPosition(position.y);
    }
  }, [refMapbox]);

  useEffect(() => {
    if (refNextMapbox.current) {
      const target = refNextMapbox.current;
      const position = target.getBoundingClientRect();
      setNextPosition(position.y);
    }
  }, [refNextMapbox]);
  useEffect(() => {
    window.history.scrollRestoration = "manual";
  }, []);

  return (
    <PageTemplate isFixed={isFixedPosition}>
      {/* 커버이미지 */}
      <CoverImage>
        <img src={IMAGE_INFO.cover.src} alt={IMAGE_INFO.cover.alt} />
      </CoverImage>
      <TitleImage src={IMAGE_INFO.title.src} alt={IMAGE_INFO.title.alt} />
      {/* 기사 타이틀 및 부제 */}
      <PageSubtitle>위드 공유킥보드 시대</PageSubtitle>
      <PageTitle>
        개인형 이동장치 PM,
        <br />
        공존을 묻다
      </PageTitle>
      {/* 섹션1 */}
      <Section
        title={ARTICLES.section1.title}
        article={ARTICLES.section1.text}
        remark={ARTICLES.section1.remark}
      ></Section>
      {/* 지도 */}
      <SectionMap />
      {/* 섹션2 */}
      <Section
        title={ARTICLES.section2.title}
        article={ARTICLES.section2.text}
      ></Section>
      <ImageBridge>
        <img src={IMAGE_INFO.subtitle.src} alt={IMAGE_INFO.subtitle.alt} />
      </ImageBridge>
      {/* 섹션3 */}
      <Section article={ARTICLES.section3.text}></Section>
      {/* 스크롤맵 */}
      <div
        ref={refMapbox}
        style={{
          width: "100%",
          height: "700px",
          margin: "50px 0",
        }}
      >
        {isFixedPosition && (
          <SectionMapWithArticle moveToUp={moveToUp} moveToDown={moveToDown} />
        )}
      </div>
      <div ref={refNextMapbox}></div>
      {/* 섹션4*/}
      <SectionFourth />
      {/* 섹션5 */}
      <Section
        title={ARTICLES.section5.title}
        article={ARTICLES.section5.text}
      ></Section>
      {/* 견인지도 */}
      <SectionMapParking />
      {/* 섹션6 */}
      <Section
        title={ARTICLES.section6.title}
        article={ARTICLES.section6.text}
      ></Section>
      <ImageBridge>
        <img src={IMAGE_INFO.parking.src} alt={IMAGE_INFO.parking.alt} />
      </ImageBridge>
      {/* 섹션7 */}
      <Section
        title={ARTICLES.section7.title}
        article={ARTICLES.section7.text}
      ></Section>
      {/* 제작진 */}
      <SectionByline>
        <ul className="list">
          <li className="row">
            <span className="row-name">데이터저널리즘팀 마부작침</span>
            <span className="row-email">sbsdjmb@gmail.com</span>
          </li>
          <li className="row">
            <span className="row-name">유덕기 기자</span>
            <span className="row-email">dkyu@sbs.co.kr</span>
          </li>
          <li className="row">
            <span className="row-name">배여운 기자</span>
            <span className="row-email">woons@sbs.co.kr</span>
          </li>
          <li className="row">
            <span className="row-name">안준석 디자이너</span>
            <span className="row-email">ahnjoonseok@sbs.co.kr</span>
          </li>
        </ul>
      </SectionByline>
    </PageTemplate>
  );
}

export default App;
